import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { animateScroll as scroll } from "react-scroll";
import Logo from "../images/logo.png";
import { addItem } from "../../context/actions/postaction";
import { resolveMediaUrl } from "../../firebase/helpers";

const ShopingCard = () => {
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const { projects } = useSelector((state) => state.projects);
  const totalItems = cart.reduce((total, item) => total + item.count, 0);

  const scrollToTop = () => {
    scroll.scrollToTop({
      duration: 50,
      smooth: "easeInOutQuint",
    });
  };

  const totalPrice = cart.reduce((total, item) => {
    const product = projects.find((productItem) => productItem.id === item.id);
    if (!product) return total;
    const itemPrice =
      Number(product.in_discount) === 1
        ? Number(product.discount_price || 0)
        : Number(product.product_price || 0);

    return total + itemPrice * item.count;
  }, 0);

  const handleIncrement = (id) => {
    dispatch({
      type: "add",
      id,
      colorId: 2,
    });
  };

  const handleDecrement = (id) => {
    dispatch({ type: "remove", id, colorId: 2 });
  };

  const handleRemove = (id) => {
    dispatch({ type: "delete", id, colorId: 2 });
  };

  const generateRandomCode = () => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let code = "";
    const codeLength = 8;

    for (let i = 0; i < codeLength; i += 1) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      code += characters.charAt(randomIndex);
    }

    return code;
  };

  const [name, setName] = useState("");
  const [note, setNote] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!name || !note || !email || !phone || !address || !city) {
      setError("جميع الحقول مطلوبة");
      scrollToTop();
      return;
    }

    const orderCode = generateRandomCode();
    const orderItems = cart
      .map((item) => {
        const product = projects.find((productItem) => productItem.id === item.id);
        if (!product) return null;

        return {
          id: item.id,
          piece: Number(item.count || 0),
          color_id: item.colorId,
          product_title_ar: product.product_title_ar,
          product_code: product.product_code,
          price: Number(product.product_price || 0),
          image: product?.images?.[0]?.product_photo || "",
        };
      })
      .filter(Boolean);

    if (!orderItems.length) {
      setError("لا توجد منتجات صالحة داخل السلة");
      return;
    }

    try {
      setIsSubmitting(true);
      setError("");

      const response = await dispatch(
        addItem(orderItems, {
          order_code: orderCode,
          name,
          email,
          phone,
          note,
          address,
          city,
        })
      );

      if (response?.status === 200) {
        setName("");
        setNote("");
        setEmail("");
        setAddress("");
        setCity("");
        setPhone("");
        dispatch({ type: "clearCart" });
        navigate(`/confirmed/${orderCode}`);
        scrollToTop();
      } else {
        setError("تعذر حفظ الطلب");
      }
    } catch (submitError) {
      setError("تعذر إتمام الطلب، حاول مرة أخرى");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div
        aria-labelledby="shoppingCartLabel"
        className="offcanvas offcanvas-end pb-sm-2 px-sm-2"
        id="shoppingCart"
        style={{ width: "500px" }}
      >
        <div className="offcanvas-header py-3 pt-lg-4 justify-content-between">
          <img style={{ width: "30%", height: "100%" }} src={Logo} alt="Logo" />
          <button aria-label="Close" className="btn " data-bs-dismiss="offcanvas" type="button">
            <i className="ci-close" />
          </button>
        </div>

        <div className="offcanvas-body d-flex flex-column gap-4 pt-2">
          {cart.length === 0 ? (
            <div className="text-center py-5 text-body-secondary">السلة فارغة حاليًا</div>
          ) : null}

          {cart.map((item) => {
            const itemInCart = projects.find((entry) => entry.id === item.id);
            if (!itemInCart) return null;

            return (
              <div key={`${item.id}-${item.colorId}`} className="d-flex align-items-center">
                <a className="flex-shrink-0" href="#!">
                  <img
                    src={resolveMediaUrl(itemInCart?.images?.[0]?.product_photo, Logo)}
                    className="bg-body-tertiary rounded"
                    width={110}
                    alt={itemInCart.product_title_ar}
                  />
                </a>
                <div className="w-100 min-w-0 ps-3">
                  <h5 className="d-flex animate-underline mb-2">
                    <a className="d-block fs-sm fw-medium text-truncate animate-target" href="#!">
                      {itemInCart.product_title_ar}
                    </a>
                  </h5>
                  <div className="h6 pb-1 mb-2">{itemInCart.product_price} د.ع</div>
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="count-input rounded-2">
                      <button
                        type="button"
                        className="btn btn-icon btn-sm"
                        onClick={() => handleDecrement(item.id)}
                        aria-label="Decrement quantity"
                      >
                        <i className="ci-minus" />
                      </button>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        value={item.count}
                        readOnly
                      />
                      <button
                        type="button"
                        className="btn btn-icon btn-sm"
                        onClick={() => handleIncrement(item.id)}
                        aria-label="Increment quantity"
                      >
                        <i className="ci-plus" />
                      </button>
                    </div>
                    <button
                      type="button"
                      className="btn-close fs-sm"
                      aria-label="Remove from cart"
                      onClick={() => handleRemove(item.id)}
                    />
                  </div>
                </div>
                <button onClick={() => handleRemove(item.id)} className="btn" type="button">
                  <i className="ci-close" />
                </button>
              </div>
            );
          })}
        </div>

        <div className="offcanvas-header flex-column align-items-start">
          <div className="d-flex align-items-center justify-content-between w-100 mb-3 mb-md-4">
            <span className="text-light-emphasis">المجموع:</span>
            <span className="h6 mb-0">{totalPrice} د.ع</span>
          </div>
          <div className="d-flex w-100 gap-3" data-bs-toggle="modal" data-bs-target="#modalId">
            <button className="btn btn-lg btn-dark w-100" type="button" disabled={!totalItems}>
              أكمال الطلب
            </button>
          </div>
        </div>
      </div>

      <div dir="rtl" className="modal fade" id="modalId" role="dialog">
        <div className="modal-dialog modal-fullscreen" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">إكمال الطلب</h5>
              <button className="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body">
              <form className="needs-validation py-2" noValidate="">
                {error ? <div className="alert alert-danger">{error}</div> : null}
                <div className="row">
                  <div className="col-md-4 position-relative mb-4">
                    <label htmlFor="validationTooltipt01" className="form-label">
                      الاسم الأول
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="validationTooltipt01"
                      placeholder="الاسم الأول"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4 position-relative mb-4">
                    <label htmlFor="validationTooltipt02" className="form-label">
                      البريد الإلكتروني
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="validationTooltipt02"
                      placeholder="البريد الإلكتروني"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4 position-relative mb-4">
                    <label htmlFor="validationTooltiptUsername" className="form-label">
                      رقم الهاتف
                    </label>
                    <input
                      type="tel"
                      className="form-control"
                      id="validationTooltiptUsername"
                      placeholder="رقم الهاتف"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 position-relative mb-4">
                    <label htmlFor="validationTooltipt03" className="form-label">
                      العنوان
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="validationTooltipt03"
                      placeholder="العنوان"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                    />
                  </div>
                  <div className="col-md-6 position-relative mb-4">
                    <label htmlFor="validationTooltipt04" className="form-label">
                      المدينة
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="validationTooltipt04"
                      placeholder="المدينة"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                    />
                  </div>
                </div>

                <div className="position-relative mb-4">
                  <label htmlFor="validationTooltipt05" className="form-label">
                    ملاحظة
                  </label>
                  <textarea
                    className="form-control"
                    id="validationTooltipt05"
                    placeholder="ملاحظة"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    rows={4}
                  />
                </div>

                <button className="btn btn-primary" type="button" onClick={handleSubmit} disabled={isSubmitting}>
                  {isSubmitting ? "جارٍ إرسال الطلب..." : "إتمام الطلب"}
                </button>
              </form>
            </div>
            <div className="modal-footer flex-column flex-sm-row align-items-stretch">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                إغلاق
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShopingCard;